import { combineReducers } from "redux";


// Authentication
import Login from "./auth/login/reducer";
import Register from "./auth/register/reducer";
import File from "./file/reducer";
import Alert from "./Alert/reducer";
import SendOtp from "./auth/sendOtp/reducer";
import VerifyEmail from "./auth/verify/reducer";
import JoinUs from "./home/joinUs/reducer";
import Currency from "./currency/reducer";
import Crypto from "./crypto/reducer";
import Settings from "./home/settings/reducer";
import Price from "./home/price/reducer";
import Wallet from "./wallet/reducer";
import Content from "./content/reducer";
import UniRamp from "./UniRamp/reducer";
import Blogs from "./blogs/reducer";
import Favourite from "./favourite/reducer";


const rootReducer = combineReducers({
  // public
  Login,
  Register,
  Alert,
  File,
  SendOtp,
  VerifyEmail,
  JoinUs,
  Currency,
  Crypto,
  Settings,
  Price,
  Wallet,
  Content,
  UniRamp,
  Blogs,
  Favourite


});

export default rootReducer;
